import CustomDownloadComponent from "../../../components/FileDownload/CustomDownloadComponent";
import UploadedDocuments from "../../../components/UploadedDocuments/UploadedDocuments";
import { UploadedDocumentData } from "../UserData";

const SellerDetails = ({ FloorCaseDetails, GetOwnerType }) => {
  const AddLabelToFile = (arr, value) => {
    //console.log("Document", value);
    return {
      label: value,
      files: arr,
    };
  };

  const VehicleInfo = FloorCaseDetails?.vehicleInfo;

  return (
    <section>
      {/* Application Preview */}
      <div className="preview-list-block">
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Seller Name:</h3>
            <p>{VehicleInfo?.seller_name}</p>
          </div>
          {/* <div className="preview-list">
            <h3>Owner ID (Last 4 Digit):</h3>
            <p>{VehicleInfo?.ownerId_last4}</p>
          </div>
          <div className="preview-list">
            <h3>Owner ID Type:</h3>
            <p>{GetOwnerType("OwnerIDType", VehicleInfo?.ownerId_type)}</p>
          </div> */}
        </div>
      </div>

      {/* Uploaded Documents */}
      <div className="preview-list-block">
        <div className="download-block">
          <h2 className="preview-subheading">Document (s) Uploaded</h2>
          <CustomDownloadComponent
            type="Flooring-Company-Details"
            appId={FloorCaseDetails?.vehicleInfo?.id}
            formType={"additional"}
          />
        </div>
        <div className="preview-list-group">
          {FloorCaseDetails?.additional?.length > 0 && (
            <UploadedDocuments
              documents={AddLabelToFile(
                FloorCaseDetails?.additional,
                "Additional Document(s)"
              )}
            />
          )}
        </div>
      </div>
    </section>
  );
};
export default SellerDetails;
